"use client";

import dynamic from "next/dynamic";
import { InputSkeleton } from "./search/input";
import { PrefSearchSkeleton } from "./search/preferences/skeleton";

// Dynamic MapProvider to avoid loading Google Maps on SSR
export const DynamicMapProvider = dynamic(() => import("@/providers/map").then(mod => ({ default: mod.MapProvider })), {
	ssr: false,
	loading: InputSkeleton,
});

// Regular import for SearchSection, but it will use DynamicMapProvider internally
export { SearchSection as DynamicSearchSection } from "./search";

export const DynamicAutoLogin = dynamic(() => import("../auto-login").then(mod => ({ default: mod.AutoLogin })), {
	ssr: false,
});

// Dynamically import the HeroPreferencesSection for better LCP
export const DynamicHeroPreferencesSection = dynamic(
	() => import("./search/preferences").then(mod => ({ default: mod.HeroPreferencesSection })),
	{
		ssr: false,
		loading: () => <PrefSearchSkeleton />,
	},
);
